<template>
    <div
        class="c-row"
        :class="{ 'contract-row--invalid': hasMissingCollectionPoint }"
    >
        <div class="c-tr">
            <div class="c-td is-1">
                <div v-text="contract.full_name" class="cux-exclude typo--lg font-weight-medium mb-1" />
                <div v-text="contract.fullAddress" class="cux-exclude typo--sm" />
            </div>

            <div class="c-td is-2">
                <span v-text="'Numer punktu zbiórki'" class="typo-label d-flex d-lg-none mb-1" />
                <span v-text="contract.externalData?.collection_point_id || '---'" />
            </div>

            <div class="c-td is-3">
                <span v-text="'Status'" class="typo-label d-flex d-lg-none mb-1" />
                <span
                    v-if="status"
                    v-text="status.text"
                    class="status w-100"
                    :class="status.class"
                />
                <span v-else v-text="'---'" />
            </div>

            <div class="c-td is-4">
                <span v-text="'Obsługiwane frakcje'" class="typo-label d-flex d-lg-none mb-1" />
                <div
                    v-for="fraction in fractions"
                    :key="fraction.id"
                >
                    <fraction-label
                        :fraction="fraction"
                        :disabled="!isFractionActive(fraction.id)"
                    />
                </div>
            </div>

            <div class="c-td is-5">
                <the-btn
                    text="Integruj sklep"
                    class="btn-primary btn-sm w-100"
                    :disabled="!isActive && !isArchived"
                    @click="goToLocationExternalData"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { CONTRACT_LOCATION_STATUSES } from '@/utils/constants/drs/operators'

export default {
    props: {
        contract: {
            type: Object,
            required: true
        }
    },

    computed: {
        ...mapGetters('drsOperators', { fractions: 'getFractions' }),

        isArchived() {
            return this.contract.locStatus === CONTRACT_LOCATION_STATUSES.ARCHIVED
        },

        isActive() {
            return this.contract.locStatus === CONTRACT_LOCATION_STATUSES.ACTIVE
        },

        hasMissingCollectionPoint() {
            return this.isActive && !this.contract.externalData?.collection_point_id
        },

        status() {
            switch (this.contract.locStatus) {
            case CONTRACT_LOCATION_STATUSES.ACTIVE:
                return { class: 'is-success', text: 'Aktywna' }
            case CONTRACT_LOCATION_STATUSES.ARCHIVED:
                return { class: 'is-secondary', text: 'Zarchiwizowana' }
            case CONTRACT_LOCATION_STATUSES.INACTIVE:
            default:
                return null
            }
        }
    },

    methods: {
        isFractionActive(frId) {
            return this.isActive && this.contract.fractions.some(({ id }) => id === frId)
        },

        goToLocationExternalData() {
            this.$store.dispatch('openModal', {
                componentPath: 'drs/operators/LocationExternalData',
                args: {
                    location: this.contract
                }
            })
        }
    }
}
</script>
